import { render, staticRenderFns } from "./contratoRenovacaoCard.vue?vue&type=template&id=2f364cfb&scoped=true"
import script from "./contratoRenovacaoCard.vue?vue&type=script&lang=js"
export * from "./contratoRenovacaoCard.vue?vue&type=script&lang=js"
import style0 from "./contratoRenovacaoCard.vue?vue&type=style&index=0&id=2f364cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f364cfb",
  null
  
)

export default component.exports